import PasswordSettings from "./PasswordSettings";

const AdvanceSettings = ({ details, getResponse, loading }) => {
  return <PasswordSettings {...{ details, getResponse, loading }} />;
};

export default AdvanceSettings;
